var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 4.83333L6.99996 7.16667L9.33329 4.83333M2.33329 0.75H11.6666C11.976 0.75 12.2728 0.872916 12.4916 1.09171C12.7104 1.3105 12.8333 1.60725 12.8333 1.91667V5.41667C12.8333 6.96376 12.2187 8.44749 11.1247 9.54146C10.0308 10.6354 8.54706 11.25 6.99996 11.25C6.23392 11.25 5.47537 11.0991 4.76764 10.806C4.05991 10.5128 3.41684 10.0831 2.87517 9.54146C1.78121 8.44749 1.16663 6.96376 1.16663 5.41667V1.91667C1.16663 1.60725 1.28954 1.3105 1.50833 1.09171C1.72713 0.872916 2.02387 0.75 2.33329 0.75Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOwner);
export default __webpack_public_path__ + "static/media/icon-owner.2fdc075c08cb2a813ce4a419142034b3.svg";
export { ForwardRef as ReactComponent };